<template>
<div class="site-wrapper">
  <div class="site-list-wrapper" v-show="fullFlag === 1 || fullFlag === 0">
    <site-list-editor
      :display-type.sync="displayType"
      :current-display-site.sync="site"
      :env-config-site-id-map="envConfigSiteIdMap"
    />
  </div>
  <div
    v-if="displayType === 1"
    v-show="fullFlag === 2 || fullFlag === 3 || fullFlag === 0"
    class="device-info-wrapper sub-list-wrapper"
    :style="{
      'padding-top': `${fullFlag === 2 || fullFlag === 3 ? '1em' : '0'}`
    }"
  >
    <site-device-list-editor
      v-show="fullFlag === 2 || fullFlag === 0"
      :site="site"
      :current-display-site-device.sync="siteDevice"
      style="padding-top:2em;"
    />
    <div
      class="site-device-factor-info-wrapper"
      v-show="fullFlag === 3 || fullFlag === 0"
    >
      <site-device-factor-list-editor
        :site-device="siteDevice"
        style="padding-top:2em;"
      />
    </div>
  </div>

  <div v-else-if="displayType === 2" class="sub-list-wrapper">
    <env-config :site="site" :env-config="envConfigSiteIdMap[site.id]" />
  </div>

  <div v-else-if="displayType === 3" class="sub-list-wrapper">
    <env-config-list-edit
      :site="site"
      :env-config="envConfigSiteIdMap[site.id]"
      style="padding-top:2em;"
      @change="onEnvConfigChanged"
    />
  </div>
</div>
</template>

<script>
import SiteListEditor from './SiteListEditor'
import SiteDeviceListEditor from './SiteDeviceListEditor'
import SiteDeviceFactorListEditor from './SiteDeviceFactorListEditor'
import EnvConfigListEdit from './EnvConfigListEdit'
import EnvConfig from './EnvConfig'
export default {
  name: 'SystemSettingsSiteDeviceFactor',
  routeInfo: {
    label: '站房管理',
    icon: 'fa fa-sitemap',
    curdInfo: {
      api: 'Site',
      id: 'id',
      name: 'name',
      editName: '站房'
    }
  },
  components: {EnvConfig, EnvConfigListEdit, SiteDeviceFactorListEditor, SiteDeviceListEditor, SiteListEditor},
  data () {
    return {
      fullFlag: 0,
      displayType: 1,
      site: Object.freeze({
        id: null
      }),
      siteDevice: Object.freeze({
        id: null
      }),
      envConfigs: Object.freeze([])
    }
  },
  computed: {
    envConfigSiteIdMap () {
      return this.envConfigs.reduce((map, envConfig) => {
        map[envConfig.siteId] = envConfig
        return map
      }, {})
    }
  },
  methods: {
    setShowFullFlag (data) {
      this.fullFlag = data
    },
    getEnvConfigs () {
      this.$api.EnvConfig.getList().then(envConfigs => {
        this.envConfigs = Object.freeze(envConfigs)
      }).catch(console.error)
    },
    onEnvConfigChanged () {
      this.getEnvConfigs()
    }
  },
  created () {
    this.getEnvConfigs()
    this.$eventBus.on('setShowFullFlag', this.setShowFullFlag)
  },
  beforeDestroy () {
    this.$eventBus.emit('setShowFullFlag', this.setShowFullFlag)
  }
}
</script>

<style lang="scss" scoped>
.site-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 12px;
  background-color: #fff;

  > * {
    flex: 1;
    min: {
      width: 0;
      height: 0;
    }
  }

  .layout-content-wrapper {
    padding-bottom: 20px !important;
  }

  /deep/ {
    .layout-content-header {
      padding: 0;
    }

    .layout-content-footer {
      height: 20px !important;
    }
  }

  > {
    .device-info-wrapper {
      display: flex;
      gap: 12px;

      > * {
        flex: 1;
        min: {
          width: 0;
          height: 0;
        }
      }
    }
  }

  > .sub-list-wrapper {
    .layout-content-wrapper {
      min-width: 0;

      /deep/ {
        .layout-content-header {
          top: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/index.vue